import {takeLatest, put} from 'redux-saga/effects';
import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  VERIFY_OPT,
  VERIFY_OPT_SUCCESS,
  VERIFY_OPT_FAILED,
  GENERATE_OPT,
  GENERATE_OPT_SUCCESS,
  GENERATE_OPT_FAILED,
} from './constants';

import {
  AuthenticationRequestBuilder,
  OptAuthenticationRequestBuilder,
  OptGenerateRequestBuilder,
} from 'client-sdk/src/authentication/authentication';
import Client from 'client-sdk/src/client';
import {Actions} from './interfaces';
import handleNotfication from '../../utils/handleNotfication';
import {handleRedirectByRule} from '../../utils/helpers';

const token = localStorage.getItem('token') || '';
export function* authentication(action: Actions): any {
  const {emailAddress, password, rememberMe} = action.payload;
  try {
    const makeAuthenticationRequest = new AuthenticationRequestBuilder()
      .data({
        emailAddress,
        password,
        rememberMe,
      })
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeAuthenticationRequest);
    if (
        response.data.role == "RONAD_ADMIN" ||
        response.data.role == "MARKETING_MANAGER" ||
        response.data.role == "MARKETING_EXPERT" ||
        response.data.role == "OPERATIONS_MANAGER" ||
        response.data.role == "OPERATIONS_EXPERT" ||
        response.data.role == "SUPPORT_MANAGER" ||
        response.data.role == "FINANCIAL_SUPERVISOR" ||
        response.data.role == "FINANCIAL_ADMIN" ||
        response.data.role == "SUPPORT_EXPERT"
    ) {
        yield put({
            type: LOGIN_SUCCESS,
            data: response.data
        });
        window.location.pathname !== "/login"
            ? window.location.reload()
            : handleRedirectByRule(response.data.role);
    } else {
        yield put({
            type: LOGIN_FAILED,
            error: "not-for-this"
        });
    }
  } catch (error) {
    yield put({
      type: LOGIN_FAILED,
      error: error.message,
    });
  }
}

export function* generateOpt(action: any): any {
  const {phoneNumber, callback} = action.payload;
  try {
    const makeAuthenticationRequest = new OptGenerateRequestBuilder()
      .data({
        phoneNumber,
      })
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeAuthenticationRequest);
    yield put({
      type: GENERATE_OPT_SUCCESS,
      data: response.data,
    });
    callback();
  } catch (error) {
    yield put({
      type: GENERATE_OPT_FAILED,
      error: error.message,
    });
  }
}

export function* verifyOpt(action: any): any {
  const {code, phoneNumber, rememberMe} = action.payload;
  try {
    const makeAuthenticationRequest = new OptAuthenticationRequestBuilder()
      .data({
        code,
        phoneNumber,
        rememberMe,
      })
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeAuthenticationRequest);
    yield put({
      type: VERIFY_OPT_SUCCESS,
      data: response.data,
    });
    handleNotfication('ورود با موفقیت انجام شد', 'success');
    window.location.pathname !== '/login'
      ? window.location.reload()
      : (window.location.href = '/orders');
  } catch (error) {
    yield put({
      type: VERIFY_OPT_FAILED,
      error: error.message,
    });
  }
}

export default function* loginSaga() {
  yield takeLatest(LOGIN, authentication);
  yield takeLatest(VERIFY_OPT, verifyOpt);
  yield takeLatest(GENERATE_OPT, generateOpt);
}
